export default __webpack_public_path__ + "static/media/home1.9836de69.png";